import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'customDate' })
export class CustomDatePipe implements PipeTransform {
  private datePipe: DatePipe = new DatePipe('pt-BR');

  transform(isoDate: string, pattern?: string): string {
    const date = new Date(isoDate);
    if (date.getFullYear() > 1) {
      return this.datePipe.transform(date, pattern);
    } else {
      return ' - ';
    }
  }
}
